import React from "react";
const About = () => {
  return (
    <div className="py-20 aboutBg md:p-10  w-full md:h-[50vh]  lg:h-[60vh] xl:px-10 -mt-20">
      <div className="md:pt-[130px]  max-w-screen-xl mx-auto px-10">
        <div className=" ">
          <div className="flex justify-center md:justify-start">
            <div className="nahid-title-designer ">
              <h2
                className=" text-[40px] text-center md:text-start mb-5"
                data-aos="zoom-in"
              >
                Welcome to
              </h2>
              <h1
                className="md:text-[40px] lg:text-[48px] text-[25px] mb-10"
                data-aos="zoom-in-up"
              >
                Matir Maya Eco Resort
              </h1>
            </div>
          </div>

          <p className="text-[18px] lg:text-[24px] text-justify md:text-start">
            Matir Maya Eco Resort started in 2020 with the aim of offering
            people an enjoyable and rejuvenating experience by immersing them in
            nature. Our expansive greenery, accompanied by an impressive lodging
            system near the lake and lush vegetation, offers guests a delightful
            and serene escape. The stunning scenery is adorned with a swimming
            pool and other facilities, while a large natural park surrounds the
            resort.
          </p>
          <p></p>
        </div>
      </div>
    </div>
  );
};

export default About;
